import React from "react"
import translate from "../../helpers/Translate"
import * as styles from './styles.module.scss'
import power_g from '../../images/icons/flash.svg'
import power_r from '../../images/icons/flash-red.svg'
import question_ico from '../../images/icons/question-icon.svg'

export const PowerRating = ({ vibrationStrength, product, isRoundup }) => {

    let soundValue

    let tooltip = { line1 : '', line2 : '' }

    const soundReduced = vibrationStrength / 100 * 5

    soundValue = parseFloat( soundReduced.toFixed(1) ) 

    let pwr

    switch ( true ) {
        case vibrationStrength <= 20:
            pwr = translate('weak')
            break;
        case vibrationStrength > 20 && vibrationStrength <= 40:
            pwr = translate('gentle')
            break;
        case vibrationStrength > 40 && vibrationStrength <= 60:
            pwr = translate('quite powerful')
            break;
        case vibrationStrength > 60 && vibrationStrength <= 80:
            pwr = translate('very powerful')
            break;
        case vibrationStrength > 80:
            pwr = translate('extremely powerful')
            break;
        default:
            break;
    }

    tooltip = {
        line1 : `${translate(`${product} was rated ${soundReduced} out of 5, which means it is`, product, soundReduced)} ${pwr}.`,
        line2 : translate(`The power rating describes how fast and strong the vibrations of ${product} felt to the reviewer.`, product)
    }

    const ratings = [ 1, 2, 3, 4, 5 ]

    if ( isRoundup ) {
        return(
        <div className={styles.vibrations__rating}>
            <div className={`${styles.tooltip} ${styles.tooltip__second}`}>
                <span>
                    {translate('Power')}
                    {isRoundup && <img src={question_ico} alt={translate('Sound rating')} />}
                </span>
                <div className={styles.hidden}>
                    <p><strong>{translate('Rating:')}</strong> {tooltip.line1}</p>
                    <p><strong>{translate('What it is:')} </strong>{tooltip.line2}</p>
                </div>
            </div>
            <div className={styles.ratings}>
                {ratings.map( ( item, id ) => 
                    item <= soundValue ? <img src={power_r} alt={translate('Sound rating')} key={`prating-${id}`} /> : <img src={power_g} alt={translate('Power rating')} key={`prating-${id}`}/>
                )}
            </div>
        </div>
        )
        
    }

    return(
        <div className={styles.recomendations__indications__item}>
            <div className={`${styles.tooltip} ${styles.tooltip__second}`}>
                <span>
                    {translate('Power:')}
                    {isRoundup && <img src={question_ico} alt={translate('Sound rating')} />}
                </span>
                <div className={styles.hidden}>
                    <p><strong>{translate('Rating:')}</strong> {tooltip.line1}</p>
                    <p><strong>{translate('What it is:')} </strong>{tooltip.line2}</p>
                </div>
            </div>
            {ratings.map( ( item, id ) => 
                item <= soundValue ? <img src={power_r} alt={translate('Sound rating')} key={`prating-${id}`} /> : <img src={power_g} alt={translate('Power rating')} key={`prating-${id}`}/>
            )}
        </div>
    )
}